import { Fragment } from 'react';
import Link from 'next/link';

/**
 * Shared GF sticky subnav: breadcrumb (Home / …crumbs / leaf) + section anchors.
 * Replaces the ~10 inline copies of the `gf-subnav` block across GF pages.
 *
 * @param {string}  lang    'ru' | 'en'
 * @param {Array}   crumbs  Intermediate breadcrumb links between Home and leaf.
 *                          Each item `{ href, label }`; falsy items are skipped.
 * @param {string}  leaf    Bold final breadcrumb segment (current page).
 * @param {Array}   anchors Section anchors `{ href, label }`.
 */
export default function GfSubnav({ lang = 'ru', crumbs = [], leaf, anchors = [] }) {
    const isRu = lang === 'ru';
    const items = (crumbs || []).filter(Boolean);

    return (
        <nav className="gf-subnav" aria-label={isRu ? 'Разделы страницы' : 'Page sections'}>
            <div className="gf-subnav-in">
                <div className="gf-crumb">
                    <Link href={`/${lang}`}>{isRu ? 'Главная' : 'Home'}</Link>
                    {items.map((c) => (
                        <Fragment key={c.href + c.label}>
                            <span className="sep">/</span>
                            <Link href={c.href}>{c.label}</Link>
                        </Fragment>
                    ))}
                    {leaf && (<><span className="sep">/</span><b>{leaf}</b></>)}
                </div>
                {(anchors || []).length > 0 && (
                    <div className="gf-anchors">
                        {anchors.map((a) => <a key={a.href + a.label} href={a.href}>{a.label}</a>)}
                    </div>
                )}
            </div>
        </nav>
    );
}
